import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {openModal} from 'ducks/modals';
import {MODALS} from 'ducks/reporting';

import './styles.css';

class ExcludeInvoicesModal extends React.Component<any> {
  render() {
    const {data: {invoices}} = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.SMALL}
        className="ExcludeInvoicesModal">
        <Modal.Header heading="Initiate GoCardless Charges" />
        <Modal.Body>
          <div className="excludedInvoicesMessage">
            The following invoices do not meet the required criteria for
            initiating GoCardless Payment and will therefore be excluded:
          </div>

          <div className="tableContainer">
            <div className="tableHeader">
              <Table>
                <Table.Header>
                  <Table.HeaderItem heading="Name" className="name" />
                  <Table.HeaderItem heading="Inv number" className="number" />
                  <Table.HeaderItem
                    heading="Exclusion reason"
                    className="reason"
                  />
                </Table.Header>
              </Table>
            </div>
            <div className="tableBody">
              <Table>
                <Table.Body>
                  {invoices &&
                    invoices.map((inv: any) => (
                      <Table.Row key={inv.id}>
                        <Table.Cell className="name">{inv.name}</Table.Cell>
                        <Table.Cell className="number">
                          {inv.idString}
                        </Table.Cell>
                        <Table.Cell className="reason">{inv.reason}</Table.Cell>
                      </Table.Row>
                    ))}
                </Table.Body>
              </Table>
            </div>
          </div>
          <div className="actionButtons">
            <Button
              white
              onClick={() => {
                this.props.closeModal();
                this.props.openModal(
                  MODALS.PREVIEW_INVOICES_FOR_PAYMENT_INITIATION
                );
              }}>
              Proceed
            </Button>
            <Button white onClick={this.props.closeModal}>
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});

const mapDispatchToProps = {
  openModal
};

export default withModal(
  MODALS.EXCLUDED_INVOICES_FROM_PAYMENT_INITIATION,
  mapStateToModalData,
  mapDispatchToProps
)(ExcludeInvoicesModal);
